import React from 'react';
import { Link } from 'react-router-dom';
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
} from './ui/navigation-menu';

/**
 * Desktop-only navigation dropdowns + inline links.
 * Renders Features/Resources mega-menus, plus Library and Pricing anchors.
 */
const NavbarDesktopMenu = ({ t }) => (
  <div className="hidden md:flex items-center space-x-8">
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="bg-transparent text-white/90 hover:text-white">
            {t.nav.features}
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 p-4">
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/features/algorithms"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                    data-testid="navbar-algorithms-link"
                  >
                    <div className="text-sm font-medium leading-none">{t.featuresMenu.algorithms}</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      {t.featuresMenu.algorithmsDesc}
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/features/risk-behavior"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                    data-testid="navbar-risk-behavior-link"
                  >
                    <div className="text-sm font-medium leading-none">{t.featuresMenu.aiPredictions}</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      {t.featuresMenu.aiPredictionsDesc}
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <NavigationMenuTrigger className="bg-transparent text-white/90 hover:text-white">
            {t.nav.resources}
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <ul className="grid w-[400px] gap-3 p-4">
              <li>
                <NavigationMenuLink asChild>
                  <a
                    href="/docs"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                  >
                    <div className="text-sm font-medium leading-none">{t.resourcesMenu.docs}</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      {t.resourcesMenu.docsDesc}
                    </p>
                  </a>
                </NavigationMenuLink>
              </li>
              <li>
                <NavigationMenuLink asChild>
                  <Link
                    to="/community"
                    className="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                    data-testid="navbar-community-link"
                  >
                    <div className="text-sm font-medium leading-none">{t.resourcesMenu.community}</div>
                    <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
                      {t.resourcesMenu.communityDesc}
                    </p>
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>

    <Link to="/docs" className="text-white/90 hover:text-white transition-colors text-sm font-medium">
      {t.nav.library}
    </Link>
    <a href="/#pricing" className="text-white/90 hover:text-white transition-colors text-sm font-medium">
      {t.nav.pricing}
    </a>
  </div>
);

export default NavbarDesktopMenu;
